import EditorJs, { API } from '@editorjs/editorjs';

import { UndoRedoState, Block } from './types';
import { getCaretPosition, setCaretPosition } from '../utils';
import { InstructionEvent } from '../../../components/script-editor/tools/types';

class UndoAndRedoListener {
  private static maxStateLength = 10;

  static state: UndoRedoState[] = [];


  static interimState: UndoRedoState;

  static step: number;

  static canPushItemToState: boolean = true;


  static async undo(editor: EditorJs) {
    if (UndoAndRedoListener.state.length) {
      UndoAndRedoListener.canPushItemToState = false;

      if (UndoAndRedoListener.step === undefined) {
        UndoAndRedoListener.step = UndoAndRedoListener.state.length - 1;
      }
      if (UndoAndRedoListener.step > 0) {
        UndoAndRedoListener.step -= 1;
      }
      const lastState = UndoAndRedoListener.state[UndoAndRedoListener.step];
      if (lastState) {
        await editor.blocks.render({ blocks: lastState.data });
        await editor.caret.setToBlock(lastState.blockIndex);
        const currentBlock = await editor.blocks.getBlockByIndex(lastState.blockIndex);
        if (currentBlock && currentBlock.holder) {
          setCaretPosition(currentBlock.holder, lastState.caretPosition);
        }
        editor.emit(InstructionEvent.UPDATE_INLINE_ACTION_EVENT_LISTENERS, {});
        editor.emit(InstructionEvent.SUBMIT_DATA, {});
      }
    }
  }

  static async redo(editor: EditorJs) {
    if (UndoAndRedoListener.state.length) {
      UndoAndRedoListener.canPushItemToState = false;
      if (UndoAndRedoListener.step < UndoAndRedoListener.maxStateLength
        && UndoAndRedoListener.step < UndoAndRedoListener.state.length - 1) {
        UndoAndRedoListener.step += 1;
      }
      const lastState = UndoAndRedoListener.state[UndoAndRedoListener.step];
      if (lastState) {
        await editor.blocks.render({ blocks: lastState.data });
        const currentBlock = await editor.blocks.getBlockByIndex(lastState.blockIndex);
        await editor.caret.setToBlock(lastState.blockIndex);

        if (currentBlock && currentBlock.holder) {
          editor.selection.expandToTag(currentBlock.holder);
          setCaretPosition(currentBlock.holder, lastState.caretPosition);
        }
        editor.emit(InstructionEvent.UPDATE_INLINE_ACTION_EVENT_LISTENERS, {});
        editor.emit(InstructionEvent.SUBMIT_DATA, {});
      }
    }
  }

  // keyup
  static async setSelectionToCurrentBlock(editor: EditorJs|API, blockIndex?: number) {
    const currentBlockIndex = blockIndex !== undefined ? blockIndex : editor.blocks.getCurrentBlockIndex();
    if (currentBlockIndex !== -1) {
      const currentBlock = editor.blocks.getBlockByIndex(currentBlockIndex);
      const range = getCaretPosition(currentBlock.holder);
      const caretPosition = (range?.toString() || '').length;
      const editorData = await editor.saver.save();
      UndoAndRedoListener.interimState = {
        data: editorData.blocks as Block[],
        caretPosition,
        blockIndex: currentBlockIndex,
      };
    }
    UndoAndRedoListener.canPushItemToState = true;
  }

  // Editor.onChange
  static async addState() {
    if (UndoAndRedoListener.canPushItemToState) {
      if (UndoAndRedoListener.interimState) {
        if (UndoAndRedoListener.state.length < UndoAndRedoListener.maxStateLength) {
          UndoAndRedoListener.state.push(UndoAndRedoListener.interimState);
          UndoAndRedoListener.step = UndoAndRedoListener.state.length - 1;
        } else {
          UndoAndRedoListener.state.shift();
          UndoAndRedoListener.state.push(UndoAndRedoListener.interimState);
          UndoAndRedoListener.step = UndoAndRedoListener.state.length - 1;
        }
      }
    }
  }
}

export default UndoAndRedoListener;
